import { onUnmounted, ref, type Ref } from 'vue';

interface DropdownHandler {
  isMenuHidden: Ref<boolean>;
  elRef: Ref<HTMLElement | null>;
  openDropdown: () => void;
  closeDropdown: () => void;
  toggleDropdown: () => void;
}
export function useDropdownHandler(): DropdownHandler {
  const isMenuHidden = ref<boolean>(true);
  const elRef = ref<HTMLElement | null>(null) as Ref<HTMLElement | null>;

  onUnmounted(() => {
    removeListener();
  });

  const addListener = (): void => {
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('click', onClick);
  };

  const removeListener = (): void => {
    document.removeEventListener('keydown', onKeyDown);
    document.removeEventListener('click', onClick);
  };

  const onKeyDown = (event: KeyboardEvent): void => {
    if (!isMenuHidden.value && event.key === 'Escape') {
      closeDropdown();
    }
  };

  const onClick = (event: Event): void => {
    if (!elRef.value?.contains(event.target as Node)) {
      closeDropdown();
    }
  };

  const openDropdown = (): void => {
    isMenuHidden.value = false;
    addListener();
  };

  const closeDropdown = (): void => {
    isMenuHidden.value = true;
    removeListener();
  };

  const toggleDropdown = (): void => {
    isMenuHidden.value = !isMenuHidden.value;
    if (isMenuHidden.value) {
      removeListener();
    } else {
      addListener();
    }
  };

  return {
    isMenuHidden,
    elRef,
    openDropdown,
    closeDropdown,
    toggleDropdown,
  };
}
